import * as React from "react";
import styled from "styled-components";
import { Button, Divider } from "antd";
import { useTranslation } from "..";
const Container = styled.div `
  padding: 24px;
`;
const Message = styled.div ``;
const Actions = styled.div `
  & > button {
    margin-right: 24px;
  }
`;
export const ErrorLayout = ({ children, reset }) => {
    const t = useTranslation();
    return (React.createElement(Container, null,
        React.createElement(Message, null, children),
        React.createElement(Divider, null),
        React.createElement(Actions, null,
            React.createElement(Button, { type: "primary", children: t("opendash:error.reload"), onClick: (e) => {
                    reset(false);
                } }),
            React.createElement(Button, { children: t("opendash:error.reset"), onClick: (e) => {
                    reset(true);
                } }))));
};
//# sourceMappingURL=ErrorBoundary.layout.js.map